var cov_2dyq5kv8oi = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Modal/index.ts",
      hash = "99037ece634c30a5243377e39c8efda54c9c03af",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Modal/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 0
        },
        end: {
          line: 5,
          column: 33
        }
      },
      "1": {
        start: {
          line: 6,
          column: 0
        },
        end: {
          line: 6,
          column: 27
        }
      },
      "2": {
        start: {
          line: 7,
          column: 0
        },
        end: {
          line: 7,
          column: 30
        }
      },
      "3": {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 8,
          column: 29
        }
      },
      "4": {
        start: {
          line: 9,
          column: 0
        },
        end: {
          line: 9,
          column: 33
        }
      },
      "5": {
        start: {
          line: 10,
          column: 0
        },
        end: {
          line: 10,
          column: 29
        }
      },
      "6": {
        start: {
          line: 11,
          column: 0
        },
        end: {
          line: 11,
          column: 26
        }
      },
      "7": {
        start: {
          line: 12,
          column: 0
        },
        end: {
          line: 12,
          column: 25
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import Modal from './Modal';
import { method, closeAll } from './events';
import Card from '../Card';
cov_2dyq5kv8oi.s[0]++;
Modal.success = method('success');
cov_2dyq5kv8oi.s[1]++;
Modal.info = method('info');
cov_2dyq5kv8oi.s[2]++;
Modal.warn = method('warning');
cov_2dyq5kv8oi.s[3]++;
Modal.error = method('error');
cov_2dyq5kv8oi.s[4]++;
Modal.confirm = method('confirm');
cov_2dyq5kv8oi.s[5]++;
Modal.show = method('normal');
cov_2dyq5kv8oi.s[6]++;
Modal.Submit = Card.Submit;
cov_2dyq5kv8oi.s[7]++;
Modal.closeAll = closeAll;
export default Modal;